/* eslint-disable no-unused-vars */
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { Matchstyles } from './matchstyles';

const FinalMatch = memo(function FinalMatch({
  homeGoals,
  awayGoals,
  penaltyScoreHome,
  penaltyScoreAway,
  teamARef,
  teamBRef,
  teamAName,
  teamBName,
  id,
}) {
  const hasPenaltyShootout =
    penaltyScoreHome !== '' &&
    penaltyScoreAway !== '' &&
    penaltyScoreHome != null &&
    penaltyScoreAway != null;

  return (
    <Matchstyles>
      <div className="final-match-wrap">
        <svg
          className="final-match-svg"
          width="276"
          height="356"
          viewBox="0 0 276 356"
        >
          <text
            x="138"
            y="35"
            textAnchor="middle"
            fontSize="26"
            fontWeight="700"
            fill="#ffe040"
            fontFamily="SBS Sans, sans-serif"
          >
            FINAL
          </text>
          <text
            x="138"
            y="58"
            textAnchor="middle"
            fontSize="16"
            fontWeight="500"
            fill="#fff"
            fontFamily="SBS Sans, sans-serif"
          >
            20 JULY 5AM
          </text>
          <text
            x="52"
            y="167"
            textAnchor="middle"
            fontSize="20"
            fontWeight="500"
            fontStretch="condensed"
            fill="#fff"
            fontFamily="SBS Sans, sans-serif"
          >
            {teamAName}
          </text>
          {homeGoals !== undefined && (
            <text
              x="52"
              y="197"
              textAnchor="middle"
              fontSize="26"
              fontWeight="700"
              fontStretch="condensed"
              fill="#fff"
              fontFamily="SBS Sans, sans-serif"
            >
              {homeGoals}
            </text>
          )}
          {hasPenaltyShootout ? (
            <text
              x="32"
              y="196"
              textAnchor="middle"
              fontSize="20"
              fontWeight="700"
              fontStretch="condensed"
              fill="#fff"
              fontFamily="SBS Sans, sans-serif"
            >
              ({penaltyScoreHome})
            </text>
          ) : null}
          <text
            x="215"
            y="167"
            textAnchor="middle"
            fontSize="20"
            fontWeight="500"
            fontStretch="condensed"
            fill="#fff"
            fontFamily="SBS Sans, sans-serif"
          >
            {teamBName}
          </text>
          {awayGoals !== undefined && (
            <text
              x="215"
              y="197"
              textAnchor="middle"
              fontSize="26"
              fontWeight="700"
              fontStretch="condensed"
              fill="#fff"
              fontFamily="SBS Sans, sans-serif"
            >
              {awayGoals}
            </text>
          )}
          {hasPenaltyShootout ? (
            <text
              x="235"
              y="196"
              textAnchor="middle"
              fontSize="20"
              fontWeight="700"
              fontStretch="condensed"
              fill="#fff"
              fontFamily="SBS Sans, sans-serif"
            >
              ({penaltyScoreAway})
            </text>
          ) : null}
        </svg>
        <div className="world-cup-images-wrap">
          {teamARef !== undefined ? (
            <img
              className="flag1"
              src={`images/${teamARef}.png`}
              alt={`Team ${teamAName} flag`}
              width="100"
              height="61"
            />
          ) : null}
          {teamBRef !== undefined ? (
            <img
              className="flag2"
              src={`images/${teamBRef}.png`}
              alt={`Team ${teamBName} flag`}
              width="100"
              height="61"
            />
          ) : null}
          <img
            className="world-cup-image"
            src="images/wc_337x137.png"
            alt="Final Match"
            width="137"
            height="337"
          />
        </div>
      </div>
    </Matchstyles>
  );
});

export default function Final({
  positions,
  homeGoals,
  awayGoals,
  penaltyScoreHome,
  penaltyScoreAway,
  teamARef,
  teamBRef,
  teamAName,
  teamBName,
  id,
}) {
  const activeButton = useSelector((state) => state.data.activeButton);

  const { x = 0, y = 0 } = positions?.[activeButton] || {};

  // over ride position for final match to be centered just incase of resizing issues
  const centeredX =
    activeButton === 'final' ? (window.innerWidth - 276) * 0.5 : x;

  return (
    <Matchstyles>
      <div
        className="match-wrap"
        style={{ transform: `translate(${centeredX}px, ${y}px)` }}
      >
        <FinalMatch
          homeGoals={homeGoals}
          awayGoals={awayGoals}
          penaltyScoreHome={penaltyScoreHome}
          penaltyScoreAway={penaltyScoreAway}
          teamARef={teamARef}
          teamBRef={teamBRef}
          teamAName={teamAName}
          teamBName={teamBName}
          id={id}
        />
      </div>
    </Matchstyles>
  );
}
